import React from "react";
import { useLocation, useParams } from "react-router-dom";
import "./PageTitle.css";

const PageTitle = () => {
  const location = useLocation();
  const { slug } = useParams();

  const path = location.pathname.replace(/\/+$/, "");
// const normalizedSlug = (slug || location.pathname.split("/").pop())?.toLowerCase();

  // Don't render PageTitle on home or sitemap page
  if (location.pathname === "/" || location.pathname === "/sitemap") {
    return null;
  }

  const rawSegment = slug || location.pathname.replace(/\/+$/, "").split("/").pop();
const normalizedSlug = rawSegment?.toLowerCase();

  const pageName = rawSegment
    ? rawSegment.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())
    : "Page";

  const pageBackgrounds = {
  "/about": "url('/images/aboutUsPageTitle.jpg')",
  "/faq": "url('/images/faqBanner.jpg')",
  "/contact": "url('/images/contactPageTitle.avif')",
  "/privacy-policy": "url('/images/privacyBanner.jpg')",
};

  const productBackgrounds = {
    "4g-smart-safety-helmet-camera": "url('/images/smartHelmetBanner.jpeg')",
    "rfi-digital-drift-leaky-feeder": "url('/images/leakyFeederBanner.png')",

    "xtreme-xp-100": "url('/images/xp100Banner.png')",
    "xtreme-xm-510": "url('/images/xm510Banner.png')",
    "xtreme-xp-446": "url('/images/xp446Banner.jpeg')",
    "xtreme-xp-880": "url('/images/xp880Banner.jpeg')",
    "xtreme-xp-960": "url('/images/xp960Banner.jpeg')",
    "xtreme-xp-220": "url('/images/xp960Banner.jpeg')",
    
     "xtreme-xp-120-mcx": "url('/images/120.jpg')",
     "xtreme-xp-660": "url('/images/660.jpg')",
     "xtreme-xp-610-mcx": "url('/images/610.jpg')",

    "xp-d15u": "url('/images/xp446Banner.jpeg')",
    "xp-d66v": "url('/images/xp960Banner.jpeg')",
    "xp-d87u": "url('/images/xp960Banner.jpeg')",

     "xtreme-xb-15": "url('/images/xb-15Banner.jpg')",
  };

  const isProductPage = location.pathname.startsWith("/product/");

const backgroundImage = isProductPage
  ? productBackgrounds[normalizedSlug] || "url('/images/default-product-banner.jpg')"
  : pageBackgrounds[path] || "url('/images/default-banner.jpg')";

  return (
    <div
      className="page-title-section"
      style={{
        backgroundImage: backgroundImage,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
      }}
    >
      <h1 className="page-title font-bold">{pageName}</h1>
    </div>
  );
};

export default PageTitle;
